<script lang="ts">
  import { createEventDispatcher } from 'svelte'
  import { Translations } from '../translations';
  import { fade } from 'svelte/transition';
  
  export let translations: Translations
  export let errors: any = {};
  export let verificationCode: string = "";

  const dispatch = createEventDispatcher()

  async function onSendCodeClicked(event: MouseEvent): Promise<void> {
    dispatch("sendCodeClick");
  }
</script>

<div in:fade class="wk-grid">
  <wk-input label='{translations.get("Verification code")}' class="wk-column-6" type-class="wk-field-small">
    <input class="wk-field-input"
           autocomplete="off"
           type='text'
           placeholder='{translations.get("Please enter your verification code")}'
           name='VerificationCode'
           required
           bind:value={verificationCode} />
    {#if errors.VerificationCode}<span class="wk-field-error field-validation-error">{errors.VerificationCode}</span>{/if}
  </wk-input>
</div>
<div in:fade class="wk-grid">
  <div class="wk-column-6">
    <button class="wk-button wk-button-text wk-idp-footer-button" on:click|preventDefault|stopPropagation={onSendCodeClicked}>{translations.get("Send Verification Email")}</button>
  </div>
</div>

<style lang="scss">
  .wk-idp-footer-button {
    padding: 0;
  }
</style>